import React from 'react';

import { InfoPageWrapper } from '../../shared/infoPageWrapper';
import MaxWidth from '../../shared/MaxWidth';
import Article from './Article';
import data from './data';
import * as S from './Press.styles';
import { SpotlightArticle } from './SpotlightArticle';

export const PressPageContent = () => {
  return (
    <InfoPageWrapper>
      <MaxWidth>
        <S.Content>
          <S.TextBox>
            <S.Caption>Press & Media</S.Caption>
            <S.Description>For press inquiries, please email press@brain.fm</S.Description>
          </S.TextBox>
          <S.Spotlight>
            <SpotlightArticle />
          </S.Spotlight>
          <S.Articles>
            {data.map((article, index) => (
              <Article
                key={index}
                img={article.img}
                site={article.site}
                text={article.title}
                url={article.url}
              />
            ))}
          </S.Articles>
        </S.Content>
      </MaxWidth>
    </InfoPageWrapper>
  );
};
